import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AgentPlatformNavbar } from '../components/Shared/AgentPlatformNavbar';
import { AgentPlatformSidebar } from '../components/Shared/AgentPlatformSidebar';
import { AGENT_PLATFORM_BASE } from '../constants/agentPlatformRoutes';
import { AgentPlatformHubPage } from '../pages/Admin/AgentPlatform/AgentPlatformHubPage';
import { AgentsListPage } from '../pages/Admin/AgentPlatform/AgentsListPage';
import { AgentEditPage } from '../pages/Admin/AgentPlatform/AgentEditPage';
import { AgentToolsPage } from '../pages/Admin/AgentPlatform/AgentToolsPage';
import { AgentToolEditPage } from '../pages/Admin/AgentPlatform/AgentToolEditPage';
import { AgentFlowsListPage } from '../pages/Admin/AgentPlatform/AgentFlowsListPage';
import { FlowComposerPage } from '../pages/Admin/AgentPlatform/FlowComposerPage';
import { AgentExecutionsPage } from '../pages/Admin/AgentPlatform/AgentExecutionsPage';
import { AgentExecutionDetailPage } from '../pages/Admin/AgentPlatform/AgentExecutionDetailPage';
import { AgentGovernancePage } from '../pages/Admin/AgentPlatform/AgentGovernancePage';
import { AutomationInstancesPage } from '../pages/Admin/AgentPlatform/AutomationInstancesPage';
import { AgentKnowledgeBasesPage } from '../pages/Admin/AgentPlatform/AgentKnowledgeBasesPage';
import { AgentKnowledgeBaseEditPage } from '../pages/Admin/AgentPlatform/AgentKnowledgeBaseEditPage';
import { AgentPlatformMonitoringPage } from '../pages/Admin/AgentPlatform/AgentPlatformMonitoringPage';

const validPrefixes = [
  AGENT_PLATFORM_BASE,
  `${AGENT_PLATFORM_BASE}/agents`,
  `${AGENT_PLATFORM_BASE}/tools`,
  `${AGENT_PLATFORM_BASE}/flows`,
  `${AGENT_PLATFORM_BASE}/executions`,
  `${AGENT_PLATFORM_BASE}/automation-instances`,
  `${AGENT_PLATFORM_BASE}/knowledge-bases`,
  `${AGENT_PLATFORM_BASE}/monitoring`,
  `${AGENT_PLATFORM_BASE}/governance`,
];

const AgentPlatformLayout: React.FC = () => {
  const location = useLocation();

  const isInvalidRoute =
    location.pathname !== AGENT_PLATFORM_BASE &&
    !validPrefixes.some(
      prefix => prefix !== AGENT_PLATFORM_BASE && location.pathname.startsWith(prefix)
    );

  if (isInvalidRoute) {
    return <Navigate to={AGENT_PLATFORM_BASE} replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <AgentPlatformNavbar />
      <div className="flex">
        <AgentPlatformSidebar />
        <main className="flex-1 min-w-0 p-0">
          <Routes>
            <Route path="/" element={<AgentPlatformHubPage />} />
            <Route path="/agents" element={<AgentsListPage />} />
            <Route path="/agents/:id" element={<AgentEditPage />} />
            <Route path="/tools" element={<AgentToolsPage />} />
            <Route path="/tools/new" element={<AgentToolEditPage />} />
            <Route path="/tools/:id/edit" element={<AgentToolEditPage />} />
            <Route path="/automation-instances" element={<AutomationInstancesPage />} />
            <Route path="/flows" element={<AgentFlowsListPage />} />
            <Route path="/flows/:id/composer" element={<FlowComposerPage />} />
            <Route path="/executions" element={<AgentExecutionsPage />} />
            <Route path="/executions/:id" element={<AgentExecutionDetailPage />} />
            <Route path="/knowledge-bases" element={<AgentKnowledgeBasesPage />} />
            <Route path="/knowledge-bases/new" element={<AgentKnowledgeBaseEditPage />} />
            <Route path="/knowledge-bases/:id/edit" element={<AgentKnowledgeBaseEditPage />} />
            <Route path="/monitoring" element={<AgentPlatformMonitoringPage />} />
            <Route path="/governance" element={<AgentGovernancePage />} />
            <Route path="*" element={<Navigate to={AGENT_PLATFORM_BASE} replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AgentPlatformLayout;
